<div class="modal is-active">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Set Customer Group Occupancy</p>
    </header>
    <section class="modal-card-body" style="min-width: 400px;">
      <form [formGroup]="Form">
        <div class="field">
          <label class="label">Current Occupancy</label>
          <div class="control">
            <input
              formControlName="occupancy"
              class="input"
              type="number"
              min="0"
              placeholder="Enter occupancy value">
            </div>
            @if (Form.get('occupancy')?.hasError('required') && Form.get('occupancy')?.touched) {
              <div class="help">
                <span class="has-text-danger">Occupancy is required</span>
              </div>
            }
            @if (Form.get('occupancy')?.hasError('min') && Form.get('occupancy')?.touched) {
              <div class="help">
                <span class="has-text-danger">Occupancy must be 0 or greater</span>
              </div>
            }
            <p class="help">
              Set the current number of occupied spaces for this customer group.
            </p>
          </div>
        </form>
      </section>
      <footer class="modal-card-foot">
        <button
          class="button is-primary"
          [disabled]="!Form.valid"
          (click)="UpdateOccupancy()">
          Update Occupancy
        </button>
        <button class="button" (click)="Cancel()">
          Cancel
        </button>
      </footer>
    </div>
  </div>